import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as Sentry from '@sentry/browser';
import { SkippableErrorHandler } from './skippable-error-handler.interface';

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler implements SkippableErrorHandler {
  handleError(error: { originalError?: unknown }): false | void {
    if (!environment.production) {
      return;
    }
    if (window.location.origin.includes('localhost')) {
      return;
    }
    Sentry.captureException(error.originalError || error);
  }
}
